import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 1023.42a32.749 32.749 0 0 1-12.28 0A781.877 781.877 0 0 1 47.376 424.73L21.792 258.428a29.679 29.679 0 0 1 16.886-31.726L499.208 3.09a30.19 30.19 0 0 1 26.608 0l460.53 223.612a29.679 29.679 0 0 1 16.886 31.726L977.647 424.73a781.877 781.877 0 0 1-453.366 598.69 32.749 32.749 0 0 1-12.281 0zM84.73 271.22l22.515 144.3A721.497 721.497 0 0 0 512 959.968 721.497 721.497 0 0 0 916.755 415.52l22.514-144.3L512 63.982z"
    />
    <path
      fill="currentColor"
      d="m270.99 584.38 27.12-37.353a92.106 92.106 0 0 0 64.985 30.19 51.17 51.17 0 0 0 51.17-54.24 47.588 47.588 0 0 0-51.17-51.17 72.15 72.15 0 0 0-44.006 15.35l-26.608-17.397 8.187-142.764H460.83v51.17H352.861l-5.628 58.333a76.755 76.755 0 0 1 35.307-8.698 85.454 85.454 0 0 1 90.57 93.64 99.27 99.27 0 0 1-102.34 102.34 134.577 134.577 0 0 1-99.78-39.4zm245.615-111.038a140.206 140.206 0 0 1 140.718-153.51 122.808 122.808 0 0 1 91.082 38.377L716.68 394.54a78.29 78.29 0 0 0-57.822-24.562c-51.17 0-82.896 38.378-82.896 102.34s29.167 102.34 86.99 102.34a58.334 58.334 0 0 0 36.842-11.257v-58.845h-51.17v-48.1h104.898v133.042a139.694 139.694 0 0 1-95.688 35.307 136.624 136.624 0 0 1-141.229-151.463z"
    />
  </svg>
);
export default SvgComponent;
